import { Controller } from "@hotwired/stimulus";

// LRPO-5507 (item 11) — a dismissible banner. The drilldown warnings block had
// no close control at all, so an invalid-filter message sat on the page until a
// full reload. The server re-renders the block on every draw, so removing the
// node here is enough: a subsequent draw that still warrants a warning ships a
// fresh one, and one that doesn't simply omits it.
export default class extends Controller {
  dismiss() {
    this.element.remove();
  }
}
